import fetch from '@adc/fetch'
import _ from 'lodash'
import configment from '@adc/configment'
import { seekTypes } from '@adc/seek'
import {
  SMALL_BATCH_THRESHOLD_COUNT,
  SMALL_BATCH_OF_VENUES_TIMEOUT,
  LARGE_BATCH_OF_VENUES_TIMEOUT,
} from '../constants/statics'
import { seekThroughGraph, seekThroughProxy } from './utils'

const getTimeOut = (venueCount = 0) =>
  configment.get('EVENT_UPDATE_REQUEST_TIMEOUT', null) ||
  venueCount < SMALL_BATCH_THRESHOLD_COUNT
    ? SMALL_BATCH_OF_VENUES_TIMEOUT
    : LARGE_BATCH_OF_VENUES_TIMEOUT

const postEvent = async (req, values) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/events`,
    {
      req,
      method: 'POST',
      body: values,
      requestTimeout: getTimeOut(_.get(values, 'venues', []).length),
    }
  )
  return res.body
}

const getEvent = async (req, id) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/events/${id}`,
    {
      req,
    }
  )
  return res.body
}

const putEvent = async (req, values) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/events/${
      values.event_id
    }`,
    {
      req,
      method: 'PUT',
      body: values,
      requestTimeout: getTimeOut(_.get(values, 'venues', []).length),
    }
  )
  return res.body
}

const getEventsThroughGraph = (req, fetchOptions) =>
  seekThroughGraph(req, fetchOptions, seekTypes.EVENTS)

const getEventsThroughProxy = (req, fetchOptions) =>
  seekThroughProxy(req, fetchOptions, 'events')

const getEvents = async (...args) =>
  configment.get('ENABLE_GRAPH_API', true)
    ? getEventsThroughGraph(...args)
    : getEventsThroughProxy(...args)

const bulkUpdateEvent = async (req, values) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/events/bulk`,
    {
      req,
      method: 'PATCH',
      body: values,
    }
  )
  return res.body
}

const getEventAggregations = async (req, fetchOptions) => {
  const res = await fetch(
    `${configment.get('RESI_CS_SEEK')}/resi/seek/v1/events/aggregate`,
    {
      req,
      method: 'POST',
      body: fetchOptions,
    }
  )
  return res.body
}

export {
  postEvent,
  getEvent,
  putEvent,
  getEvents,
  getEventAggregations,
  bulkUpdateEvent,
}
